import { Component, OnInit, Input } from '@angular/core';
import Swal from 'sweetalert2';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import {CommonService} from '../../services/common.service';
import { APIService } from 'src/app/api.service';
import {DataService} from '../../services/data.service';
import { CopyFromProductComponent } from '../copy-from-product/copy-from-product.component';
import { StageConfigComponent } from '../../production/stage-config/stage-config.component'
import { Subject } from 'rxjs';
// import { debug } from 'console';


@Component({
  selector: 'app-stage-selection',
  templateUrl: './stage-selection.component.html',
  styleUrls: ['./stage-selection.component.scss']
})
export class StageSelectionComponent implements OnInit {

  changingValue: Subject<boolean> = new Subject();
  changingHeadValue: Subject<boolean> = new Subject();

  constructor(private modalService: NgbModal, private router: Router, public commonFun: CommonService,
    private apiService: APIService, private dataSer: DataService) {
      this.dataSer.productStages.subscribe((value) => {
        let val: any = value;
        if(val.productID) {
          this.productID = val.productID;
          this.stageData = value;
        }
        
      });
      this.getData();

     }

  

  //#region "Declaration"
  @Input() mdlRef: any;
  @Input() stageData: any;
  @Input() isProjectType: any = false;
  prductData: any = {
    productID: 0,
    productName: 'Blue Led Light'
  };
  productID: number = 0;
  jarvisData: any = [];
  agencyData: any = [];
  stageList: any = [];
  tmpSelectedStgList: any = [];
  right: any = []

    selectedStages: any = [];

    stageEntry: any = {
      stageID: 0,
      stageName: '',
      stageOrder: 0,
      userIDs: ''
    }

	stageFlowList: any = [];
    stageFlowName: string = '';

  modalReference: any;
  stageSelection: any;
  closeResult: any;
  isEdit: boolean = false;
  //#endregion
   
  ngOnInit(): void {
    // let productID = this.commonFun.GetParam("PID");
    // this.prductData.productID = productID;

    let jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
          this.jarvisData = JSON.parse(jarvis);
    }

    this.right = this.apiService.getCookie("J");
    if(this.right){
      this.right = JSON.parse(this.right);
      let ownUserID: number = this.jarvisData[0].UserID;
      this.right = $.grep(this.right, function(o: any){ return o.UserID == ownUserID })[0];
      if(!this.right.InvMstrs && !this.right.InvCfg && !this.right.InvRpts && !this.right.InvXns){
        window.location.href = "../../main.html#/home";
        return;
      }
    }
      if(this.stageData.productID) {
        this.getData();
      }
  }

  getData() {
    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }

    let jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
          this.jarvisData = JSON.parse(jarvis);
          this.prductData.productID = this.stageData.productID;
          this.prductData.productName = this.stageData.productName;
          this.selectedStages = JSON.parse(this.stageData.stages);
          this.getStages();

          // this.dataSer.dataTransfer.subscribe((value :any) => {
          //   this.prductData.productName = value.productName;
          //   this.selectedStages = JSON.parse(value.stages);
          //   console.log(value);
          //   this.getStages();
          // })
          //this.getProductDetail();
    }; 
  }

  //#region "Function"
  
    addNewStages(){

      let tmpStgName = this.stageEntry.stageName;
      let tmpSelectedStageList = this.selectedStages.filter(function (element: any, index: any) {
          return (element.SNm == tmpStgName);
      });
      if(tmpSelectedStageList.length > 0) {
        this.apiService.successAlert("This stage already exists.");
        this.stageEntry.stageID = 0;
        this.stageEntry.stageName = '';
        this.stageEntry.stageOrder = 0;
        this.stageEntry.userIDs = '';
        this.stageEntry.TID = 1;
        return;
      }
      if(this.stageEntry.stageID == 0 || this.stageEntry.stageName == ''){
        this.apiService.successAlert("Please select a stage.");
        return;
      }

      this.selectedStages.push({
        SID: this.stageEntry.stageID,
        SNm: this.stageEntry.stageName,
        UIDs: this.stageEntry.userIDs,     
        Seq: this.stageEntry.stageOrder,
        TID: this.stageEntry.TID
      });
      this.stageEntry.stageName = ""; 
      this.filterStageList();
      this.saveStages();
      this.modalReference.close();
      // this.closeModal();
    }

    open(content: any) {
        this.stageSelection = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false });
    }

    closeModalStage($event: any) {
      this.stageEntry.stageName = "";
      this.stageSelection.close();
      if ($event) {
        this.changingValue.next($event);
        this.changingHeadValue.next($event);
      }
    }

    openStageConfig() {
      this.modalReference = this.modalService.open(StageConfigComponent, { windowClass: 'modal-stage-Entry', backdrop: 'static', keyboard: false });
      this.modalReference.componentInstance.mdlRef = this.modalReference;
      this.modalReference.result.then((result: any) => {
        if (result.action == 'Done') {
          let cnfg; 
          cnfg = this.apiService.getCookie('ERP_Cfg');
          if(cnfg) {
            cnfg = JSON.parse(cnfg);
            if(cnfg.length > 0) {
              this.stageList = JSON.parse(cnfg[0].PrdJobStages)
            }
          }
         
        }
      })
    }

    displayStageNames() {

      if (!this.stageFlowName) {
        this.apiService.successAlert("Please select a stage flow.");
        return;
      }

      let selectedFlow = this.stageFlowList.find((flow: any) => flow.StageFlow == this.stageFlowName);

      if (selectedFlow && selectedFlow.Stages) {
        this.selectedStages.push(...(JSON.parse(selectedFlow.Stages)));
      } 
      else {
        this.apiService.successAlert("Stage flow not found.");
      }
      this.saveStages();
      this.stageSelection.close();
    }

    fn_ChangeStage() {
      let stageName = this.stageEntry.stageName;
      if(!stageName){
          return;
      }
      let tmpStageList = this.stageList.filter(function (element: any, index: any) {
          return (element.SNm == stageName);
      });

      if (tmpStageList.length > 0) {
        // let tmpSelectedStageList = this.selectedStages.filter(function (element: any, index: any) {
        //     return (element.SNm == stageName);
        // });
        // if(tmpSelectedStageList.length > 0){
        //   alert("This stage already exists.");
        //   this.stageEntry.stageID = 0;
        //   this.stageEntry.stageName = '';
        //   this.stageEntry.stageOrder = 0;
        //   this.stageEntry.userIDs = '';
        //   return;
        // }
        // else{
          this.stageEntry.stageID = tmpStageList[0].SID;
          this.stageEntry.stageName = tmpStageList[0].SNm;
          this.stageEntry.stageOrder = tmpStageList[0].Seq;    
          this.stageEntry.userIDs = tmpStageList[0].UIDs;
          this.stageEntry.TID = tmpStageList[0].TID;
        // }
          
      }
      else {
        this.stageEntry.stageID = 0;
        this.stageEntry.stageName = '';
        this.stageEntry.stageOrder = 0;
        this.stageEntry.userIDs = '';
        this.stageEntry.TID = 1;
        this.apiService.successAlert("Please select valid stage.")
      }
    }

    removeStage(ind: any){
      var r = confirm("Are you sure you want to delete this stage?");

      if(r == true) {
        this.selectedStages.splice(ind, 1);
      } 
      else {
        return;
      }

      if(this.selectedStages.length == 0){
          this.saveStages();
      }
      this.filterStageList();

    }

    goBack(){
      // window.history.back();
      this.mdlRef.close('Close');
    }

  //saveStages() - Save Stages in Database
  saveStages(){
    let MyLastSyncDT = localStorage.getItem("MyLastSyncDT");

    // if(this.selectedStages.length == 0){
    //   this.apiService.successAlert('Please enter stages.');
    //   return;
    // }

    
    this.selectedStages.forEach((obj: any, index: any) => {
      obj.Seq = index + 1; // Assign sequence starting from 1
    });

    let tempData = [{
      ItemID: this.prductData.productID,
      ChangeType: 'PRDSTG',
      BOM: '[]',
      Byproducts: '[]',
      Stages: JSON.stringify(this.selectedStages),
      Units: '[]'
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: MyLastSyncDT,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'setItemDetail',
      moduleID: 5,
      data: JSON.stringify(tempData)
    }];

    this.apiService.sendChange(myParams, this.successStageEntry.bind(this), this.failureStageResp.bind(this));

  }

    //failureResp - failure handler
    failureStageResp(res: any) {
      if (res.error) {
      }
      else {
        this.apiService.successAlert(res.message);
      }
    }
  
    //successResp - success  get handler
    successStageEntry(res: any) {
      if (res.error) {
      }
      else {
          if (res) {
            var reponseData = JSON.parse(res.updatePackage);
            if(reponseData.Table[0].ErrCode == 1){
              this.apiService.successAlert(reponseData.Table[0].ErrMsg);
                // this.router.navigateByUrl('/Stock');
            }
            else{
              if(this.mdlRef) {
                this.mdlRef.close('Done');
              }
              else {
                this.isEdit = false;
              }
              
              // this.router.navigateByUrl('/ProductDetail?PID=' + this.prductData.productID);
            }
          }
      }
    }

    //getProductDetail() - Get Product Details
  getStages(){
    var tempData = [{
      'changeType': 'STAGEFLOW',
    }]
    let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        myLastSyncDT: null,
        isWeb: true,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        actionType: 'getConfig',
        moduleID: 6,
        data: JSON.stringify(tempData)
    }];

    this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this));  
  }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }

  //successResp - success  get handler
  successResp(res: any) {
    if (res.error) {
    }
    else {
        if (res) {
          var reponseData = JSON.parse(res.updatePackage);
          if(reponseData.Table[0].ErrCode == 1){
            this.apiService.successAlert(reponseData.Table[0].ErrMsg);
              // this.router.navigateByUrl('/Stock');
          }
          else{
            let unitData = reponseData.Table2[0];
            this.stageList = JSON.parse(unitData.PrdJobStages);
            this.filterStageList();
            if (reponseData.Table4) {
              this.stageFlowList = reponseData.Table4;
            }
          }
        }
    }
  }

  copyFromProduct() {
    this.modalReference = this.modalService.open(CopyFromProductComponent, { windowClass : "itemSelectionModalClass", backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.typeID = 1; // Copy Stages
    this.modalReference.componentInstance.ri = this.productID; // Remove This Item
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    this.modalReference.result.then((result: any) => {
      if(result.length > 0) {
        this.selectedStages = result;

        this.saveStages();
      }
      
    });
  }

  isEditTrue() {
    this.tmpSelectedStgList = JSON.parse(JSON.stringify(this.selectedStages));
    this.isEdit = true;
  }

  cancelStages() {
    this.selectedStages = this.tmpSelectedStgList;
    this.isEdit = false;
  }

  filterStageList() {
    let cnfg: any = this.apiService.getCookie('ERP_Cfg');
    if(cnfg) {
      cnfg = JSON.parse(cnfg);
      if(cnfg.length > 0) {
        this.stageList = JSON.parse(cnfg[0].PrdJobStages)
      }
    }
    this.stageList = this.stageList.filter((stage: any) => {
      return !this.selectedStages.some((selected: any) => selected.SID === stage.SID);
    })
  }

  //#endregion
}
